module.exports = __webpack_public_path__ + "img/type--4-spans--multiple-lang--es.675117f7.jpg";